import { OktaAuthService } from '@services/_iam/okta-auth.service';

export function appInitializerFactory(oktaAuthService: OktaAuthService) {
  // return () => oktaAuthService.initialize();
  return async () => {
    const isCallbackRoute = window.location.pathname.includes('/login/callback');
    if (isCallbackRoute) {
      // On the callback route, OktaCallbackComponent exclusively handles
      // handleLoginRedirect(). We must NOT call initialize() here as it would
      // consume the one-time authorization code first, causing
      // "AuthSdkError: The auth transaction has already been completed".
      // We still register token listeners so that when OktaCallbackComponent
      // stores the tokens, storeUser() and storeAccessToken() fire correctly
      // and populate localStorage before the post-login navigation occurs.
      await oktaAuthService.setupTokenListeners();
      return Promise.resolve(true);
    }
    const isAuthenticated = await oktaAuthService.isAuthenticated();
    if (!isAuthenticated) {
      return oktaAuthService.initialize();
    }
    return Promise.resolve(true);
  }
}